"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const menuBtn = document.querySelector(".menu--burger");
const menu = document.querySelector(".menu--links");
const menuLinks = document.querySelectorAll(".menu--links__el");

if (menuBtn && menu) {
  menuBtn.addEventListener("click", () => {
    const isHidden = menu.classList.contains("menu--links__hidden");

    if (isHidden) {
      menu.classList.remove("menu--links__hidden");

      gsap.fromTo(menuLinks, { 
        opacity: 0, 
        y: 20 
      },
      { 
        opacity: 1, 
        y: 0, 
        duration: 0.4, 
        stagger: 0.4, 
        ease: "ease-out" 
      });
    } 
    
    else {
      menu.classList.add("menu--links__hidden");

      gsap.to(menuLinks, {
        opacity: 0,
        y: 20,
        duration: 0.3,
        stagger: 0.1,
        ease: "ease-out"
      });
    }
  });
}



const nomEl = document.getElementById('nom');
const descriptionEl = document.getElementById('description');

let diplomesH2, formationsH2;

const diplomesEl = document.getElementById('diplomes');
const formationsEl = document.getElementById('formations');

if (diplomesEl && formationsEl) {
  diplomesH2 = diplomesEl.previousElementSibling;
  formationsH2 = formationsEl.previousElementSibling;
}

let medecinsData = {};
let medecinIds = [];
let currentIndex = 0;

const urlParams = new URLSearchParams(window.location.search);
const urlId = urlParams.get('id');


fetch('assets/data/medecin.json')
  .then(response => {
    if (!response.ok) throw new Error('Impossible de charger le JSON');
    return response.json();
  })
  .then(data => {
    medecinsData = data;
    medecinIds = Object.keys(data);

  
    if (urlId && medecinIds.includes(urlId)) {
      currentIndex = medecinIds.indexOf(urlId);
    } else {
      currentIndex = 0;
    }

    afficherMedecin(currentIndex);
  })
  .catch(error => console.error('Erreur:', error));


function afficherMedecin(index) {
  const medecinId = medecinIds[index];
  const medecin = medecinsData[medecinId];

  if (!medecin) {
    console.error(`Médecin avec l'ID ${medecinId} non trouvé.`);
    return;
  }

  
  const noms = medecin.nom.split(' ');
  if (noms.length > 1) {
    const prenom = noms.slice(0, -1).join(' ');
    const nomFamille = noms[noms.length - 1].toUpperCase();
    nomEl.textContent = `${prenom} ${nomFamille}`;
  } else {
    nomEl.textContent = medecin.nom.toUpperCase();
  }

  
  document.querySelectorAll('.medecin--photo').forEach(img => img.style.display = 'none');
  const imgMedecin = document.getElementById(medecinId);
  if (imgMedecin) imgMedecin.style.display = 'block';

  
  if (medecin.description && medecin.description.length > 0) {
    descriptionEl.innerHTML = medecin.description.map(desc => `<p>${desc}</p>`).join('');
    descriptionEl.style.display = '';
  } else {
    descriptionEl.style.display = 'none';
  }

  
  if (medecin.diplomes && medecin.diplomes.length > 0) {
    diplomesEl.innerHTML = medecin.diplomes.map(d => `<li>${d}</li>`).join('');
    diplomesEl.style.display = '';
    if (diplomesH2) diplomesH2.style.display = '';
  } else {
    diplomesEl.style.display = 'none';
    if (diplomesH2) diplomesH2.style.display = 'none';
  }

  
  if (medecin.formations && medecin.formations.length > 0) {
    formationsEl.innerHTML = medecin.formations.map(f => `<li>${f}</li>`).join('');
    formationsEl.style.display = '';
    if (formationsH2) formationsH2.style.display = '';
  } else {
    formationsEl.style.display = 'none';
    if (formationsH2) formationsH2.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  gsap.from('.intro--anim, .team--title__big, .tarif--title__big', {
    duration: 0.8,
    y: 20,
    opacity: 0,
    ease: 'power2.out',
    stagger: 0.2 
  });


  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".text--anim").forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%", 
        toggleActions: "restart reset restart reset" 
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  
});





var oldScroll = 0;
var sticky = document.querySelector(".menu"); 

window.addEventListener("scroll", scrollListener);

function scrollListener(){

  
  if(oldScroll > window.scrollY){
    // si je remonte
    sticky.classList.remove("menu--close")
  } else {
      //si je descend
      sticky.classList.add("menu--close")
  }

  oldScroll = window.scrollY;
}